// extracted by mini-css-extract-plugin
module.exports = {"light":"reach_light__yu6nC","dark":"reach_dark__90nNM"};